// extracted by mini-css-extract-plugin
export default {"root":"Buffer_root__RFfsl","animate":"Buffer_animate__gekCk"};